import React from 'react';

export const CateringContactBanner = () => (
  <section className="catering-contact-section ps-container-lg-margin ps-container-fixed">
    <div className="ps-row">
      <div className="col-xs-12 catering-contact-section-inner">
        <h5 className="tw-headline-1-m md:tw-headline-3-b no-margin">
          Need help? Or want to discuss custom options?
        </h5>
        <p className="tw-body-4 md:tw-headline-5 no-margin">
          Contact us at{' '}
          <br className="catering-contact-br-hidden-desktop" />
          <a href="mailto:catering@peerspace.com" className="text-white">
            catering@peerspace.com
          </a>
        </p>
      </div>
    </div>
  </section>
);
